import React from 'react';
import { createIcon } from '../../../utils';

const IconTeams = createIcon({
  viewBox: '0 0 28 28',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7917 7.65289C24.7917 8.94922 23.7408 10.0001 22.4445 10.0001C21.1482 10.0001 20.0973 8.94922 20.0973 7.65289C20.0973 6.35655 21.1482 5.30566 22.4445 5.30566C23.7408 5.30566 24.7917 6.35655 24.7917 7.65289ZM18.6528 11.585V16.9457C18.6528 17.881 19.0244 18.778 19.6858 19.4394C20.3471 20.1008 21.2441 20.4723 22.1794 20.4723H22.3484C23.2837 20.4722 24.1807 20.1007 24.842 19.4393C25.5034 18.778 25.875 17.881 25.8751 16.9457V12.0418C25.875 11.7876 25.7739 11.5438 25.5941 11.3641C25.4143 11.1844 25.1705 11.0834 24.9163 11.0834H19.1544C19.0214 11.0834 18.8938 11.1363 18.7997 11.2304C18.7057 11.3244 18.6528 11.452 18.6528 11.585Z"
        fill="#5059C9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2919 6.75C18.2919 8.54493 16.8369 10 15.0419 10C13.247 10 11.7919 8.54493 11.7919 6.75C11.7919 4.95507 13.247 3.5 15.0419 3.5C16.8369 3.5 18.2919 4.95507 18.2919 6.75ZM10.2273 11.0833H19.8566C19.9837 11.0839 20.1094 11.1095 20.2266 11.1587C20.3438 11.2078 20.4501 11.2796 20.5396 11.3699C20.629 11.4601 20.6998 11.5672 20.7478 11.6848C20.7959 11.8024 20.8203 11.9284 20.8197 12.0554V17.8888C20.8197 19.4212 20.211 20.8908 19.1275 21.9743C18.0439 23.0579 16.5743 23.6666 15.0419 23.6666C13.5096 23.6666 12.04 23.0579 10.9564 21.9743C9.8729 20.8908 9.26417 19.4212 9.26417 17.8888V12.0554C9.26355 11.9284 9.28798 11.8024 9.33605 11.6848C9.38412 11.5672 9.45489 11.4601 9.54433 11.3699C9.63376 11.2796 9.74011 11.2078 9.85728 11.1587C9.97446 11.1095 10.1002 11.0839 10.2273 11.0833Z"
        fill="#7B83EB"
      />
      <path
        d="M13.7175 7.8335H4.08808C3.55619 7.8335 3.125 8.26468 3.125 8.79658V18.426C3.125 18.9579 3.55619 19.3891 4.08808 19.3891H13.7175C14.2494 19.3891 14.6806 18.9579 14.6806 18.426V8.79658C14.6806 8.26468 14.2494 7.8335 13.7175 7.8335Z"
        fill="url(#paint0_linear_3933_44636)"
      />
      <path
        d="M11.3852 11.3869H9.51212V16.8613H8.32045V11.3869H6.45459V10.3613H11.3852V11.3869Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3933_44636"
          x1="5.13278"
          y1="7.0813"
          x2="12.6728"
          y2="20.1412"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A62C3" />
          <stop offset="0.5" stopColor="#4D55BD" />
          <stop offset="1" stopColor="#3940AB" />
        </linearGradient>
      </defs>
    </>
  ),
});

export default IconTeams;
